import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex flex-column flex-grow-1" };
const _hoisted_2 = { class: "title-input" };
const _hoisted_3 = ["rows", "placeholder", "maxlength", "disabled", "dir"];
const _hoisted_4 = { class: "d-flex justify-content-end length-input mt-1" };
import { ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextArea',
    props: {
        modelValue: { type: String },
        title: { type: String, },
        text: { type: String },
        maxNumber: { type: Number },
        language: { type: String },
        rows: { type: Number },
        placeholder: { type: String },
        disabled: { type: Boolean },
        isRtl: { type: Boolean, default: false }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const content = ref(props.text);
        watch(content, newValue => {
            emit('update:modelValue', newValue);
        });
        watch(() => props.modelValue, val => content.value = val);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1),
                _withDirectives(_createElementVNode("textarea", {
                    class: "w-100 main-input mt-1",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((content).value = $event)),
                    rows: props.rows,
                    placeholder: props.placeholder,
                    maxlength: props.maxNumber,
                    disabled: props.disabled,
                    dir: __props.isRtl ? 'rtl' : 'ltr'
                }, "    ", 8, _hoisted_3), [
                    [_vModelText, content.value]
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(content.value?.length) + "   /   " + _toDisplayString(props.maxNumber), 1)
            ]));
        };
    }
});
